const getters = {
    journalentry: (state) => state.journalentry,
    id: (state) => state.id,
    loading: state => state.loading
};

export default getters;